import { editChannel } from '@/app/util/channel-api'
import { FlashMessageContext } from '@/context/flash-message'
import { IChannel } from '@giphy/js-types'
import { usePathname, useRouter } from 'next/navigation'
import { ReactNode, useContext } from 'react'
import { ModalContext } from '../../modal'
import { useChannelMutate } from '../hooks'

const EditCollectionForm = ({
    className,
    children,
    channelId,
}: {
    channelId: number
    className?: string
    children: ReactNode
}) => {
    const { showStatusMessage } = useContext(FlashMessageContext)
    const { goBack, modal } = useContext(ModalContext)
    const mutateChannel = useChannelMutate()
    const router = useRouter()
    const pathname = usePathname()
    return (
        <form
            id="editForm"
            autoComplete="off"
            className={className}
            action={async (formData: FormData) => {
                const result = await editChannel(channelId, formData)
                showStatusMessage('Collection Saved', 'Failed to update collection', result.ok)
                if (result.ok) {
                    const updatedChannel = (await result.json()) as IChannel
                    if (
                        modal?.name === 'editCollection' &&
                        modal.channel.url === pathname &&
                        updatedChannel.url !== pathname
                    ) {
                        // this url is no longer valid
                        router.replace(updatedChannel.url)
                    } else {
                        await mutateChannel(updatedChannel)
                        goBack()
                    }
                }
            }}
        >
            {children}
        </form>
    )
}

export default EditCollectionForm
